

define(['jquery', 'squid/index', 'text!./template.html', '../../fi-contingency-list/contingencies', 'components/xo-page-components/src/aside-header/directive', 'components/xo-ui-components/src/error-tooltip/directive'], function ($, squid, template) {

    return squid.module('xo-add-bank.sepa.directive', ['squid', 'xo-aside-header.directive', 'xo-error-tooltip.directive']).directive('xoSepa', function ($state, $timeout) {
        return {
            template: template,

            scope: {
                token: '=',
                parentCallbacks: '=',
                model: '=',
                sidebar: '=',
                hideparenthead: '='
            },

            controller: function controller($scope) {

                if (!$scope.model) {
                    return $state.go('^.add');
                }

                $('body').addClass('pageSepaMandate');

                $scope.$on('$destroy', function () {
                    $('body').removeClass('pageSepaMandate');
                });

                if ($scope.hideparenthead) {
                    $scope.hideparenthead.toggle = true;
                }

                function getDate() {
                    var today = new Date();
                    var dd = today.getDate();
                    var mm = today.getMonth() + 1; // January is 0!

                    var yyyy = today.getFullYear();
                    if (dd < 10) {
                        dd = '0' + dd;
                    }
                    if (mm < 10) {
                        mm = '0' + mm;
                    }
                    return dd + '.' + mm + '.' + yyyy;
                }

                $scope.date = getDate();

                $scope.onSubmit = function () {
                    $scope.parentCallbacks.sepaDone();
                };
            },

            link: function link($scope, element, attrs) {
                $timeout(function () {
                    $(element).find('.asideContent').height($('#main').height() - $('#tray').find('.header').height() + 10);
                }, 10);
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/add-bank/sepa/directive.js
 ** module id = 262
 ** module chunks = 1
 **/